import React, {useState} from 'react';
import {Helmet} from 'react-helmet';

import {title} from 'lib/head';

import AccountTypeStep from './AccountTypeStep';
import SignUpFormStep from './SignUpFormStep';
import SignUpCarousel, {SignUpCarouselMobile} from './SignUpCarousel';
import SignUpStudentPanel from './SignUpStudentPanel';

interface NewSignUpPageProps {
  accountType?: string;
}

export default function NewSignUpPage({accountType}: NewSignUpPageProps) {
  const validAccountType =
    accountType === 'educator' || accountType === 'student' ? accountType : null;

  const [selectedType, setSelectedType] = useState<string | null>(validAccountType);

  const showStudentPanel = selectedType === 'student' || validAccountType === 'student';

  return (
    <>
      <Helmet>{title('Sign Up | Albert')}</Helmet>
      <div className='-mt-[60px] flex min-h-[calc(100vh-60px)] flex-col m:flex-row'>
        {/* Form content */}
        <div className='flex w-full flex-col items-center justify-center p-x4 m:w-1/2'>
          {validAccountType ? (
            <SignUpFormStep accountType={validAccountType} />
          ) : (
            <AccountTypeStep onTypeChange={setSelectedType} />
          )}
        </div>

        {/* Mobile carousel */}
        <div className='m:hidden'>
          <SignUpCarouselMobile />
        </div>

        {/* Desktop right panel */}
        <div className='hidden m:block m:w-1/2'>
          {showStudentPanel ? <SignUpStudentPanel /> : <SignUpCarousel />}
        </div>
      </div>
    </>
  );
}
